<script>
export let src = ""
</script>

<img src="{src}" class="w-full {$$props.className || ''}" alt="" />
